import { CustomRow } from 'components/Table/helpers';
import { PLACEHOLDER } from 'helpers/enums';
import { LagDateInformation } from 'components/LagDateBadge/LagDateBadge';
import { serverDateToFormat } from 'helpers/formatters/date';
import { BenchmarkMetadataSmallDisplayTestIds } from 'helpers/testIds';
import { PullForward } from 'types/PullForward';

type Properties = {
  benchmark: PullForward;
};

export const SmallDisplay = ({ benchmark }: Properties) => {
  const { badge, date } = LagDateInformation({
    isLagged: benchmark.isLagged,
    defaultLagDate: benchmark.defaultLagDate,
    customLagDate: benchmark.customLagDate,
  });

  return (
    <div className='d-none d-block d-sm-none d-sm-block d-md-block d-lg-none'>
      <div className='row'>
        <div className='col'>
          <table className='table table-borderless table-sm'>
            <thead>
              <tr>
                <th scope='col'></th>
                <th scope='col'></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope='row'>ID</th>
                <td data-testid={BenchmarkMetadataSmallDisplayTestIds.Id}>
                  {benchmark?.id}
                </td>
              </tr>
              <tr>
                <th scope='row'>Benchmark Type</th>
                <td data-testid={BenchmarkMetadataSmallDisplayTestIds.Type}>
                  {benchmark?.type?.name}
                </td>
              </tr>
              <tr>
                <th scope='row'>Base Currency</th>
                <td
                  data-testid={
                    BenchmarkMetadataSmallDisplayTestIds.BaseCurrency
                  }
                >
                  {benchmark?.baseCurrencyCode}
                </td>
              </tr>
              <tr>
                <th scope='row'>Calculation Frequency</th>
                <td
                  data-testid={
                    BenchmarkMetadataSmallDisplayTestIds.CalculationFrequency
                  }
                >
                  {benchmark?.calculationFrequency?.name}
                </td>
              </tr>
              <tr>
                <th scope='row'>Inception</th>
                <td
                  data-testid={
                    BenchmarkMetadataSmallDisplayTestIds.InceptionDate
                  }
                >
                  {benchmark?.inceptionDate
                    ? serverDateToFormat(benchmark.inceptionDate)
                    : ''}
                </td>
              </tr>
              <tr>
                <th scope='row'>Created</th>
                <td
                  data-testid={BenchmarkMetadataSmallDisplayTestIds.CreatedDate}
                >
                  {benchmark?.createdDate
                    ? serverDateToFormat(benchmark?.createdDate)
                    : ''}
                </td>
              </tr>
              {benchmark.isLagged ? (
                <tr>
                  <th scope='row'>Lag Date {badge}</th>
                  <td
                    data-testid={BenchmarkMetadataSmallDisplayTestIds.LagDate}
                  >
                    {date}
                  </td>
                </tr>
              ) : null}
              {benchmark?.calculationFrequency?.id === 1 ? (
                <tr>
                  <th scope='row'>Calendar Type</th>
                  <td
                    data-testid={
                      BenchmarkMetadataSmallDisplayTestIds.PACalendar
                    }
                  >
                    {benchmark?.portfolioAnalyticsCalendar
                      ? benchmark?.portfolioAnalyticsCalendar.name
                      : ''}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
        <div className='col'>
          <table className='table table-borderless table-sm'>
            <thead>
              <tr>
                <th scope='col'></th>
                <th scope='col'></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope='row'>Booked Values</th>
                <td
                  data-testid={
                    BenchmarkMetadataSmallDisplayTestIds.IncludeBookedValues
                  }
                >
                  {benchmark?.includeBookedValues ? 'Included' : 'Not Included'}
                </td>
              </tr>
              <CustomRow
                fullWidth={
                  !!benchmark?.description && benchmark?.description.length > 40
                }
                content={benchmark?.description || PLACEHOLDER.dashes}
                thName='Description'
                tdProps={{
                  'data-testid':
                    BenchmarkMetadataSmallDisplayTestIds.Description,
                  colSpan: 2,
                }}
              />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
